(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 87794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(78731);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/core/components/common/AppHead.tsx
var AppHead = __webpack_require__(46055);
// EXTERNAL MODULE: ./src/core/layouts/AppLayout.tsx + 27 modules
var AppLayout = __webpack_require__(74797);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@mantine/form/esm/use-form.js + 15 modules
var use_form = __webpack_require__(98903);
// EXTERNAL MODULE: ./src/core/data/countries-list.ts
var countries_list = __webpack_require__(84738);
// EXTERNAL MODULE: ./src/core/constants/app-consts.ts
var app_consts = __webpack_require__(7350);
// EXTERNAL MODULE: ./src/core/components/form/skin-active/InputField.tsx
var InputField = __webpack_require__(16751);
// EXTERNAL MODULE: ./src/core/components/form/skin-active/EmailField.tsx
var EmailField = __webpack_require__(28270);
// EXTERNAL MODULE: ./src/core/components/form/skin-active/CountryField.tsx
var CountryField = __webpack_require__(76684);
// EXTERNAL MODULE: ./src/core/components/form/skin-active/PhoneNumberField.tsx
var PhoneNumberField = __webpack_require__(58566);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
;// CONCATENATED MODULE: ./node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js


var index =  react.useLayoutEffect ;

/* harmony default export */ var use_isomorphic_layout_effect_browser_esm = (index);

;// CONCATENATED MODULE: ./node_modules/use-latest/dist/use-latest.esm.js



var useLatest = function useLatest(value) {
  var ref = react.useRef(value);
  use_isomorphic_layout_effect_browser_esm(function () {
    ref.current = value;
  });
  return ref;
};



;// CONCATENATED MODULE: ./node_modules/use-composed-ref/dist/use-composed-ref.esm.js


var updateRef = function updateRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
    return;
  }
  ref.current = value;
};

var useComposedRef = function useComposedRef(libRef, userRef) {
  var prevUserRef = (0,react.useRef)();
  return (0,react.useCallback)(function (instance) {
    libRef.current = instance;

    if (prevUserRef.current) {
      updateRef(prevUserRef.current, null);
    }

    prevUserRef.current = userRef;

    if (!userRef) {
      return;
    }

    updateRef(userRef, instance);
  }, [userRef]);
};

/* harmony default export */ var use_composed_ref_esm = (useComposedRef);

;// CONCATENATED MODULE: ./node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js






var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};

var forceHiddenStyles = function forceHiddenStyles(node) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
};

//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259

var hiddenTextarea = null;

var getHeight = function getHeight(node, sizingData) {
  var height = node.scrollHeight;

  if (sizingData.sizingStyle.boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
  } // remove padding, since height = content


  return height - sizingData.paddingSize;
};

function calculateNodeHeight(sizingData, value, minRows, maxRows) {
  if (minRows === void 0) {
    minRows = 1;
  }

  if (maxRows === void 0) {
    maxRows = Infinity;
  }

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    hiddenTextarea.setAttribute('tabindex', '-1');
    hiddenTextarea.setAttribute('aria-hidden', 'true');
    forceHiddenStyles(hiddenTextarea);
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  }

  var paddingSize = sizingData.paddingSize,
      borderSize = sizingData.borderSize,
      sizingStyle = sizingData.sizingStyle;
  var boxSizing = sizingStyle.boxSizing;
  Object.keys(sizingStyle).forEach(function (_key) {
    var key = _key;
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  forceHiddenStyles(hiddenTextarea);
  hiddenTextarea.value = value;
  var height = getHeight(hiddenTextarea, sizingData); // measure height of a textarea with a single row

  hiddenTextarea.value = 'x';
  var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
  var minHeight = rowHeight * minRows;

  if (boxSizing === 'border-box') {
    minHeight = minHeight + paddingSize + borderSize;
  }

  height = Math.max(minHeight, height);
  var maxHeight = rowHeight * maxRows;

  if (boxSizing === 'border-box') {
    maxHeight = maxHeight + paddingSize + borderSize;
  }

  height = Math.min(maxHeight, height);
  return [height, rowHeight];
}

var noop = function noop() {};
var pick = function pick(props, obj) {
  return props.reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
};

var SIZING_STYLE = ['borderBottomWidth', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'boxSizing', 'fontFamily', 'fontSize', 'fontStyle', 'fontWeight', 'letterSpacing', 'lineHeight', 'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop', // non-standard
'tabSize', 'textIndent', // non-standard
'textRendering', 'textTransform', 'width', 'wordBreak'];
var isIE = !!document.documentElement.currentStyle ;

var getSizingData = function getSizingData(node) {
  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = pick(SIZING_STYLE, style);
  var boxSizing = sizingStyle.boxSizing; // probably node is detached from DOM, can't read computed dimensions

  if (boxSizing === '') {
    return null;
  } // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths


  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
  var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
  return {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize
  };
};

var useWindowResizeListener = function useWindowResizeListener(listener) {
  var latestListener = useLatest(listener);
  (0,react.useLayoutEffect)(function () {
    var handler = function handler(event) {
      latestListener.current(event);
    };

    window.addEventListener('resize', handler);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, []);
};

var TextareaAutosize = function TextareaAutosize(_ref, userRef) {
  var cacheMeasurements = _ref.cacheMeasurements,
      maxRows = _ref.maxRows,
      minRows = _ref.minRows,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$onHeightChange = _ref.onHeightChange,
      onHeightChange = _ref$onHeightChange === void 0 ? noop : _ref$onHeightChange,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"]);

  if (false) {}

  var isControlled = props.value !== undefined;
  var libRef = (0,react.useRef)(null);
  var ref = use_composed_ref_esm(libRef, userRef);
  var heightRef = (0,react.useRef)(0);
  var measurementsCacheRef = (0,react.useRef)();

  var resizeTextarea = function resizeTextarea() {
    var node = libRef.current;
    var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData(node);

    if (!nodeSizingData) {
      return;
    }

    measurementsCacheRef.current = nodeSizingData;

    var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows),
        height = _calculateNodeHeight[0],
        rowHeight = _calculateNodeHeight[1];

    if (heightRef.current !== height) {
      heightRef.current = height;
      node.style.setProperty('height', height + "px", 'important');
      onHeightChange(height, {
        rowHeight: rowHeight
      });
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      resizeTextarea();
    }

    onChange(event);
  };

  {
    (0,react.useLayoutEffect)(resizeTextarea);
    useWindowResizeListener(resizeTextarea);
  }

  return /*#__PURE__*/(0,react.createElement)("textarea", (0,esm_extends/* default */.Z)({}, props, {
    onChange: handleChange,
    ref: ref
  }));
};

var react_textarea_autosize_browser_esm_index = /* #__PURE__ */(0,react.forwardRef)(TextareaAutosize);

/* harmony default export */ var react_textarea_autosize_browser_esm = (react_textarea_autosize_browser_esm_index);

// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-id/use-id.js
var use_id = __webpack_require__(36289);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(64761);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Textarea/Textarea.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  input: {
    paddingTop: theme.spacing.xs,
    paddingBottom: theme.spacing.xs
  }
}));

/* harmony default export */ var Textarea_styles = (useStyles);
//# sourceMappingURL=Textarea.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/style-system-props/extract-system-styles/extract-system-styles.js
var extract_system_styles = __webpack_require__(12756);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Input/Input.js + 11 modules
var Input = __webpack_require__(94151);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Textarea/Textarea.js








var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  autosize: false,
  size: "sm",
  __staticSelector: "Textarea"
};
const Textarea = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Textarea", defaultProps, props), {
    autosize,
    maxRows,
    minRows,
    label,
    error,
    description,
    id,
    className,
    required,
    style,
    wrapperProps,
    classNames,
    styles,
    size,
    __staticSelector,
    sx,
    errorProps,
    descriptionProps,
    labelProps,
    inputWrapperOrder,
    inputContainer,
    unstyled,
    withAsterisk
  } = _a, others = __objRest(_a, [
    "autosize",
    "maxRows",
    "minRows",
    "label",
    "error",
    "description",
    "id",
    "className",
    "required",
    "style",
    "wrapperProps",
    "classNames",
    "styles",
    "size",
    "__staticSelector",
    "sx",
    "errorProps",
    "descriptionProps",
    "labelProps",
    "inputWrapperOrder",
    "inputContainer",
    "unstyled",
    "withAsterisk"
  ]);
  const uuid = (0,use_id/* useId */.M)(id);
  const { classes, cx } = Textarea_styles();
  const { systemStyles, rest } = (0,extract_system_styles/* extractSystemStyles */.x)(others);
  const sharedProps = __spreadValues({
    required,
    ref,
    invalid: !!error,
    id: uuid,
    classNames: __spreadProps(__spreadValues({}, classNames), { input: cx(classes.input, classNames == null ? void 0 : classNames.input) }),
    styles,
    __staticSelector,
    size,
    multiline: true,
    unstyled
  }, rest);
  return /* @__PURE__ */ react.createElement(Input/* Input.Wrapper */.I.Wrapper, __spreadValues(__spreadValues({
    label,
    error,
    id: uuid,
    description,
    required,
    style,
    className,
    classNames,
    styles,
    size,
    __staticSelector,
    sx,
    errorProps,
    labelProps,
    descriptionProps,
    inputContainer,
    inputWrapperOrder,
    unstyled,
    withAsterisk
  }, systemStyles), wrapperProps), autosize ? /* @__PURE__ */ react.createElement(Input/* Input */.I, __spreadProps(__spreadValues({}, sharedProps), {
    component: react_textarea_autosize_browser_esm,
    maxRows,
    minRows
  })) : /* @__PURE__ */ react.createElement(Input/* Input */.I, __spreadProps(__spreadValues({}, sharedProps), {
    component: "textarea",
    rows: minRows
  })));
});
Textarea.displayName = "@mantine/core/Textarea";


//# sourceMappingURL=Textarea.js.map

// EXTERNAL MODULE: ./node_modules/@tabler/icons/icons-react/dist/index.esm.js
var index_esm = __webpack_require__(63991);
;// CONCATENATED MODULE: ./src/core/components/form/skin-active/MessageField.tsx





var MessageField_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        textArea: {
            position: "relative",
            "Textarea": {
                height: "auto",
                paddingTop: 50,
                paddingBottom: 4,
                fontSize: 14
            },
            "& .mantine-Textarea-icon": {
                top: -20,
                fontSize: 20
            },
            "label": {
                position: "absolute",
                pointerEvents: "none",
                fontSize: theme.fontSizes.sm,
                paddingLeft: theme.spacing.sm,
                paddingTop: 20 / 2,
                zIndex: 1
            },
            "& .mantine-Textarea-description": {
                position: "absolute",
                pointerEvents: "none",
                fontSize: theme.fontSizes.xs,
                paddingLeft: theme.spacing.sm,
                paddingTop: 28,
                zIndex: 1,
                color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
            },
            "& .mantine-Textarea-input::placeholder": {
                color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7]
            },
            "& .mantine-InputWrapper-error": {
                fontSize: 12,
                paddingTop: 6
            }
        }
    };
});
var MessageField = function(param) {
    var variable = param.variable, form = param.form, defaultValue = param.defaultValue, errorMsg = param.errorMsg, fieldLabel = param.fieldLabel, placeholder = param.placeholder, description = param.description, inputVariant = param.inputVariant, required = param.required, disabled = param.disabled;
    var classes = MessageField_useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea, (0,_object_spread/* default */.Z)({
        className: classes.textArea,
        mt: "sm",
        radius: "xs",
        label: fieldLabel,
        placeholder: placeholder,
        description: description,
        error: errorMsg,
        required: required,
        disabled: disabled,
        variant: inputVariant,
        defaultValue: defaultValue,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconMessage */.fu1, {
            size: 16,
            stroke: 1
        }),
        autosize: true,
        minRows: 4,
        maxRows: 4
    }, form.getInputProps(variable)));
};

// EXTERNAL MODULE: ./src/core/router/AppRoutes.ts
var AppRoutes = __webpack_require__(84396);
// EXTERNAL MODULE: ./src/core/utils/index.ts
var utils = __webpack_require__(47048);
// EXTERNAL MODULE: ./src/core/hooks/useNotification.ts
var useNotification = __webpack_require__(96682);
// EXTERNAL MODULE: ./src/generated/graphql.tsx
var graphql = __webpack_require__(89402);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/features/auth/contact-us/components/ContactUsForm.styles.ts


/* harmony default export */ var ContactUsForm_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        form: // borderRight: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[3]}`,
        // minHeight: 900,
        // maxWidth: 450,
        // paddingTop: 80,
        (0,_define_property/* default */.Z)({}, "@media (max-width: ".concat(theme.breakpoints.sm, "px)"), {
            maxWidth: "100%"
        }),
        submitButton: {
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: 1
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/auth/contact-us/components/ContactUsForm.tsx




















var ContactUsForm = function() {
    var classes = ContactUsForm_styles().classes;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), countryValue = ref[0], setCountryValue = ref[1];
    var ref1 = (0,react.useState)([]), callingCodes = ref1[0], setCallingCodes = ref1[1];
    // CALL
    var notify = (0,useNotification/* default */.Z)().notify;
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(""), callError = ref3[0], setCallError = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useSendInquiryEmailMutation */.Rx)(), 1), sendInquiryEmailMutation = ref4[0];
    var validateForm = function(values) {
        return {
            name: (0,utils/* empty */.cS)(values.name) ? "Name is required" : (0,utils/* validateInputLength */.tE)(values.name, 3, "Name is too short"),
            email: (0,utils/* empty */.cS)(values.email) ? "Email is required" : (0,utils/* validateEmail */.oH)(values.email, "Please input valid email address."),
            country: (0,utils/* empty */.cS)(values.country) ? "Country is required" : null,
            phoneNumber: (0,utils/* empty */.cS)(values.phoneNumber) ? "Phone number is required" : (0,utils/* validateInputLength */.tE)(values.phoneNumber, 7, "Please input a valid phone number"),
            phoneNumberCallingCode: (0,utils/* empty */.cS)(values.phoneNumberCallingCode) ? "Calling code is required" : null,
            message: (0,utils/* empty */.cS)(values.message) ? "Message is required" : (0,utils/* validateInputLength */.tE)(values.message, 7, "Message is too short")
        };
    };
    var form = (0,use_form/* useForm */.c)({
        initialValues: {
            name: "",
            email: "",
            country: "",
            phoneNumber: "",
            phoneNumberCallingCode: "",
            message: ""
        },
        validateInputOnChange: [
            "name",
            "email",
            "country",
            "phoneNumber",
            "phoneNumberCallingCode",
            "message"
        ],
        validate: function(values) {
            setCountryValue(values.country);
            return validateForm(values);
        }
    });
    (0,react.useEffect)(function() {
        if (countryValue) {
            var ref;
            var allCountries = countries_list/* CountriesList.flat */.$.flat();
            var selectedCountry = allCountries.filter(function(item) {
                return item.label === countryValue;
            });
            setCallingCodes(selectedCountry === null || selectedCountry === void 0 ? void 0 : (ref = selectedCountry[0]) === null || ref === void 0 ? void 0 : ref.callingCodes);
            if (selectedCountry.length) {
                form.setFieldValue("phoneNumberCallingCode", selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry[0].callingCodes[0]);
            }
        }
    }, [
        countryValue
    ]);
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var record;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        record = {
                            name: values.name,
                            email: values.email,
                            country: values.country,
                            phone: "+".concat(values.phoneNumberCallingCode, "-").concat(values.phoneNumber),
                            message: values.message
                        };
                        // console.log(JSON.stringify(record, null, 2), 'onSubmit_');
                        setIsLoading(true);
                        return [
                            4,
                            sendInquiryEmailMutation({
                                variables: {
                                    input: record
                                }
                            }).then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                                    var data;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        data = param.data;
                                        // console.log('D>> ', data);
                                        if (data.sendInquiryEmail.status === app_consts/* SUCCESS */.MR) {
                                            setCallError("");
                                            setIsLoading(false);
                                            /*notify(
                        NotificationType.SUCCESS,
                        `${data.sendInquiryEmail.data}`
                    );*/ router.push(AppRoutes/* AppRoutes.RESPONSE */.$w.RESPONSE).catch(console.error);
                                        }
                                        if (data.sendInquiryEmail.error) {
                                            // message.error("Error " + data.sendInquiryEmail.error)
                                            setCallError(data.sendInquiryEmail.error);
                                            setIsLoading(false);
                                            notify(useNotification/* NotificationType.ERROR */.k.ERROR, "".concat(data.sendInquiryEmail.error));
                                        }
                                        return [
                                            2
                                        ];
                                    });
                                });
                                return function(_) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(error) {
                                console.error("sendInquiryEmail", error);
                                setCallError(error);
                                setIsLoading(false);
                                notify(useNotification/* NotificationType.ERROR */.k.ERROR, "Error unable to reach server ".concat(error), false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: classes.form,
        onSubmit: form.onSubmit(handleSubmit),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputField/* InputField */.U, {
                form: form,
                variable: "name",
                fieldLabel: "Please enter your full name",
                placeholder: "example: John Doe",
                description: "Make sure it matches the name on your passport."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailField/* EmailField */.s, {
                form: form,
                variable: "email",
                fieldLabel: "Please enter your email address",
                placeholder: "example@gmail.com",
                description: "We’ll email you regarding your trip."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CountryField/* CountryField */.D, {
                form: form,
                variable: "country",
                fieldLabel: "Country",
                placeholder: "You can type or use the dropdown",
                description: "Please select your country",
                searchable: true,
                clearable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneNumberField/* PhoneNumberField */.g, {
                form: form,
                variable: "phoneNumber",
                subCompVariable: "phoneNumberCallingCode",
                subCompData: callingCodes,
                fieldLabel: "Number",
                description: "Please enter your number",
                searchable: true,
                clearable: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageField, {
                form: form,
                variable: "message",
                fieldLabel: "Message",
                placeholder: "I would like to get more information on...",
                description: "Please enter your message"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                variant: "filled",
                className: classes.submitButton,
                radius: "xs",
                type: "submit",
                loading: isLoading,
                fullWidth: true,
                mt: "xl",
                children: "Submit"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/auth/contact-us/containers/ContactUsLanding.styles.ts

/* harmony default export */ var ContactUsLanding_styles = ((0,create_styles/* createStyles */.k)(function(theme) {
    return {
        paper: {
            margin: "0 auto",
            textAlign: "justify",
            fontSize: 13,
            maxWidth: 500,
            padding: 20,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: theme.colorScheme === "dark" ? theme.colors.gray[8] : theme.colors.gray[3],
            boxShadow: theme.shadows.sm,
            color: theme.colorScheme === "dark" ? theme.colors.gray[0] : theme.colors.gray[7]
        },
        h1: {
            textAlign: "center",
            letterSpacing: 0.6
        },
        h2: {
            textAlign: "center",
            letterSpacing: 0.6,
            color: theme.colors.orange[5]
        }
    };
}));

;// CONCATENATED MODULE: ./src/features/auth/contact-us/containers/ContactUsLanding.tsx





var ContactUsLanding = function() {
    var classes = ContactUsLanding_styles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
            className: classes.paper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                    mb: 20,
                    className: classes.h1,
                    order: 1,
                    children: "Contact Us"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsForm, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/contact-us.tsx




var ContactUsPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsLanding, {});
};
// @ts-expect-error
ContactUsPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHead/* default */.Z, {
                title: "Contact Us",
                description: "Would you like to get in touch with us? Send us a message and let us know what we can do for you."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppLayout/* default */.Z, {
                requireAuth: false,
                children: page
            })
        ]
    });
};
/* harmony default export */ var contact_us = (ContactUsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [584,662,930,151,810,985,7,207,98,774,888,377], function() { return __webpack_exec__(87794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);